import { render, staticRenderFns } from "./driverOrder.vue?vue&type=template&id=31cdeda0&scoped=true&"
import script from "./driverOrder.vue?vue&type=script&lang=js&"
export * from "./driverOrder.vue?vue&type=script&lang=js&"
import style0 from "./driverOrder.vue?vue&type=style&index=0&id=31cdeda0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cdeda0",
  null
  
)

export default component.exports